import React from 'react';
import './effectBlocks.css';

/**
 * AiBanner — the "this editor was seeded by an AI suggestion" strip shown at the
 * top of a block editor. Renders nothing when there's no rationale, so editors
 * can drop it in unconditionally.
 */
function AiBanner({ rationale }) {
    if (!rationale) return null;
    return (
        <div className="eb-ai-banner">
            <span className="eb-ai-badge">AI</span>
            <span>{rationale}</span>
        </div>
    );
}

export default AiBanner;
